"use client";

import { c as _c } from "react/compiler-runtime";
import React, { useEffect, useState } from "react";
import WaveDropQuote from "./WaveDropQuote";
import { commonApiFetch } from "@/services/api/common-api";
import { useQuery } from "@tanstack/react-query";
import { WaveDropsSearchStrategy } from "@/contexts/wave/hooks/types";
import type { ApiWaveDropsFeed } from "@/generated/models/ApiWaveDropsFeed";
import type { ApiDrop } from "@/generated/models/ApiDrop";
import { QueryKey } from "@/components/react-query-wrapper/ReactQueryWrapper";
interface WaveDropQuoteWithSerialNoProps {
  readonly serialNo: number;
  readonly waveId: string;
  readonly onQuoteClick: (drop: ApiDrop) => void;
  readonly embedPath?: readonly string[] | undefined;
  readonly quotePath?: readonly string[] | undefined;
  readonly embedDepth?: number | undefined;
  readonly maxEmbedDepth?: number | undefined;
}
const WaveDropQuoteWithSerialNo: React.FC<WaveDropQuoteWithSerialNoProps> = t0 => {
  const $ = _c(15);
  const {
    serialNo,
    waveId,
    onQuoteClick,
    embedPath,
    quotePath,
    embedDepth,
    maxEmbedDepth
  } = t0;
  let t1;
  if ($[0] !== serialNo || $[1] !== waveId) {
    t1 = {
      queryKey: [QueryKey.DROPS, {
        waveId,
        limit: 1,
        dropId: null,
        serialNo,
        strategy: WaveDropsSearchStrategy.Both
      }],
      queryFn: async () => {
        const params = {
          limit: "1",
          serial_no_limit: `${serialNo}`,
          search_strategy: WaveDropsSearchStrategy.Both
        };
        const results = await commonApiFetch({
          endpoint: `waves/${waveId}/drops`,
          params
        });
        return results;
      }
    };
    $[0] = serialNo;
    $[1] = waveId;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const {
    data
  } = useQuery(t1);
  const [drop, setDrop] = useState(null);
  let t2;
  if ($[3] !== data || $[4] !== serialNo) {
    t2 = () => {
      const targetDrop = data?.drops.find(drop_0 => drop_0.serial_no === serialNo);
      if (targetDrop && data?.wave) {
        setDrop({
          ...targetDrop,
          wave: data.wave
        });
      }
    };
    $[3] = data;
    $[4] = serialNo;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== data) {
    t3 = [data];
    $[6] = data;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  useEffect(t2, t3);
  let t4;
  if ($[8] !== drop || $[9] !== embedDepth || $[10] !== embedPath || $[11] !== maxEmbedDepth || $[12] !== onQuoteClick || $[13] !== quotePath) {
    t4 = <WaveDropQuote drop={drop} partId={1} onQuoteClick={onQuoteClick} embedPath={embedPath} quotePath={quotePath} embedDepth={embedDepth} maxEmbedDepth={maxEmbedDepth} />;
    $[8] = drop;
    $[9] = embedDepth;
    $[10] = embedPath;
    $[11] = maxEmbedDepth;
    $[12] = onQuoteClick;
    $[13] = quotePath;
    $[14] = t4;
  } else {
    t4 = $[14];
  }
  return t4;
};
export default WaveDropQuoteWithSerialNo;